import Vue from 'vue'
import VueRouter from 'vue-router'
// https://github.com/declandewet/vue-meta
import VueMeta from 'vue-meta'
import { Auth } from 'aws-amplify'

// Adds a loading bar at the top during page loads.
// import NProgress from 'nprogress/nprogress'
// import store from '@state/store'
import { allRoutes } from './routes'

if (process.env.NODE_ENV === 'production') {
  require('@src/app.config')
} else {
  require('@src/app.config.dev')
}

Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page'
})

const router = new VueRouter({
  routes: allRoutes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// router.beforeResolve((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     let user;
//     Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(data => {
//       if (data && data.signInUserSession) {
//         user = data;
//       }
//       next()
//     }).catch((e) => {
//       next({
//         path: '/',
//         query: {
//           redirect: to.fullPath,
//         }
//       });
//     });
//   }
//   next()
// })

// router.beforeResolve(async (to, from, next) => {
//
//   let allowed = true
//   const requiredUserGroups = to.meta.requiresUserGroups || []
//
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     try {
//       const caUser = await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
//       const caGroups = caUser.signInUserSession.idToken.payload["cognito:groups"] || []
//       if (caGroups.length === 0 && requiredUserGroups.length > 0) allowed = false
//       if (requiredUserGroups.length > 0
//           && !requiredUserGroups.some(group => caGroups.includes(group)))  {
//         allowed = false
//       }
//     } catch (e) {
//       next({
//         path: "/",
//         query: {
//           redirect: to.fullPath
//         }
//       })
//     }
//   }
//   if (allowed) {
//     next()
//   } else {
//     next({
//       path: "/404",
//     })
//   }
// })

// router.beforeResolve(async (to, from, next) => {

//   let allowed = false
//   const requiredUserGroups = to.meta.requiresUserGroups || []

//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     try {
//       const caUser = await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
//       const caGroups = caUser.signInUserSession.idToken.payload["cognito:groups"] || []

//       if (requiredUserGroups.length === 0) allowed = true
//       if (requiredUserGroups.length > 0 && caGroups.length > 0 &&
//           requiredUserGroups.some(group => caGroups.includes(group))) allowed = true

//     } catch (e) {
//       next({
//         path: "/",
//         query: {
//           redirect: to.fullPath
//         }
//       })
//     }
//   } else {
//     allowed = true
//   }
//   if (allowed) {
//     next()
//   } else {
//     next({
//       path: "/404",
//     })
//   }
// })

router.beforeResolve(async (to, from, next) => {
  let allowed = false
  const requiredUserGroups = to.meta.requiresUserGroups || []

  console.log('requiredUserGroups', requiredUserGroups)
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    console.log('to-required auth', to)

    try {
      const caUser = await Auth.currentAuthenticatedUser()
      const caGroups =
        caUser.signInUserSession.idToken.payload['cognito:groups'] || []

      if (requiredUserGroups.length === 0) {
        allowed = true
      }
      if (
        requiredUserGroups.length > 0 &&
        caGroups.length > 0 &&
        requiredUserGroups.some((group) => caGroups.includes(group))
      ) {
        allowed = true
      }
    } catch (e) {
      console.log('error', e)
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    allowed = true
  }

  if (allowed) {
    next()
  } else {
    next({
      path: '/404'
    })
  }
})

export default router
